import { useQuery } from 'react-query';
import useAuth from '../use-auth';
import { queryOptions } from '../use-hydra';
import {
  getProsumerProject,
  getProsumerProjectsDashboard,
} from '../../api/prosumer';

export function useProsumerProject(projectSlug: string) {
  const { getTokenSilently, isAuthenticated } = useAuth();

  const state = useQuery(
    ['get-prosumer-project', isAuthenticated, projectSlug],
    async () => {
      if (!isAuthenticated) {
        return null;
      }
      const token = await getTokenSilently();
      const project = await getProsumerProject(token, {
        projectSlug,
      });

      return project;
    },
    queryOptions
  );
  return {
    value: state.data,
    loading: state.isLoading,
    error: state.error,
    retry: state.refetch,
  };
}

export function useProsumerProjectsDashboard() {
  const { getTokenSilently, isAuthenticated } = useAuth();

  const state = useQuery(
    ['get-prosumer-projects-dashboard', isAuthenticated],
    async () => {
      if (!isAuthenticated) {
        return null;
      }
      const token = await getTokenSilently();
      const projects = await getProsumerProjectsDashboard(token);
      return projects;
    },
    queryOptions
  );
  return {
    value: state.data,
    loading: state.isLoading,
    error: state.error,
    retry: state.refetch,
  };
}
